<template>
    <div :class="['flex flex-nowrap w-full items-center gap-2 overflow-x-auto overflow-y-hidden py-1', classAdd]">
        <!-- All button -->
        <button
            @click="setCurrentItem(null)"
            :class="[
                'whitespace-nowrap px-3 py-1.5 rounded-md font-medium text-xs transition-all duration-200',
                activeItem === null
                    ? 'bg-primary text-white shadow-sm'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            ]"
        >
            All
        </button>

        <!-- Filter items -->
        <button
            v-for="item in items"
            :key="getItemId(item)"
            @click="setCurrentItem(getItemId(item))"
            :class="[
                'whitespace-nowrap px-3 py-1.5 rounded-md font-medium text-xs transition-all duration-200',
                activeItem === getItemId(item)
                    ? 'bg-primary text-white shadow-sm'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            ]"
        >
            {{ getItemLabel(item) }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'FilterLane',
    props: {
        items: {
            type: Array,
            required: true
        },
        classAdd: {
            type: String,
            default: ''
        },
        allLabel: {
            type: String,
            default: 'Semua'
        },
        idKey: {
            type: String,
            default: 'id'
        },
        labelKey: {
            type: String,
            default: 'name'
        }
    },
    data() {
        return {
            activeItem: null
        }
    },
    methods: {
        setCurrentItem(item) {
            this.activeItem = item;
            this.$emit('setCurrentItem', item);
        },
        getItemId(item) {
            return typeof item === 'object' ? item[this.idKey] : item;
        },
        getItemLabel(item) {
            return typeof item === 'object' ? item[this.labelKey] : item;
        }
    }
}
</script>

<style scoped>
.overflow-x-scroll::-webkit-scrollbar {
    height: 6px;
    width: 6px;
}

.overflow-x-scroll::-webkit-scrollbar-track {
    @apply bg-gray-100 rounded-full;
}

.overflow-x-scroll::-webkit-scrollbar-thumb {
    @apply bg-gray-400 rounded-full hover:bg-gray-500;
}
</style>
